import { render, staticRenderFns } from "./MyClients.vue?vue&type=template&id=458adec5&"
import script from "./MyClients.vue?vue&type=script&lang=js&"
export * from "./MyClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports